module.exports = __webpack_public_path__ + "48775b2c9fdec5f9335d60adad357d6d.pdf";